import { useTenant } from '../../../providers/tenant';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useQuery from '../../../hooks/useQuery';
import { ERROR_KEYS } from '../../../util/constants';
import { Util, AccountManager } from '@bluedolphin/util-module-mf';
import { useSnackbar } from '@bluedolphin/ui';

/**
 * ErrorHandler page component
 *
 * @returns {JSX.Element}
 */
export default function ErrorHandler(): JSX.Element {
    const { error: loginError } = useQuery();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const { tenantMeta: tenant } = useTenant();
    const history = useHistory();

    /**
     * clear the URL after error is toasted
     */
    function clearUrlAfterError() {
        setTimeout(() => {
            if (history.location.search.includes('?error=')) {
                history.replace(history.location.pathname);
            }
        }, 5000);
    }

    useEffect(() => {
        if (tenant?.name && !Util.isSupportedBrowser()) {
            enqueueSnackbar(t('unSupportedBrowser.warning'), {
                variant: 'error',
            });
            clearUrlAfterError();
        }
    }, [tenant]);

    useEffect(() => {
        if (tenant?.name && loginError) {
            const loginErrorKey = ERROR_KEYS[loginError] || 'default';
            enqueueSnackbar(t(`loginErrors.${loginErrorKey}`), {
                variant: 'error',
                preventDuplicate: true,
            });
            AccountManager.setItem('logout', true);
            clearUrlAfterError();
        }
    }, [tenant, loginError]);

    return null;
}
